import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import FactorykaOnDemand from '../assets/facsupervisorlogo.png';
import ErrorModal from './ErrorModal';
import PhoneOtpForm from './PhoneOtpForm';
import useFcmToken from '../hooks/useFcmToken';

const AdminLogin = () => {
  const { loading, verifyAdminOtp, adminLogin, logout, token } = useAuth();
  const navigate = useNavigate();

  const [phone, setPhone] = useState('');
  const [acceptedWhatsApp] = useState(true);
  const [acceptedTerms, setAcceptedTerms] = useState(true);
  const [otp, setOtp] = useState('');
  const [showOtp, setShowOtp] = useState(false);
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);

  // ✅ Capture FCM token from native WebView injection
  useFcmToken();

  useEffect(() => {
    if (token) {
      const isTablet = localStorage.getItem('isTablet') === 'true';
      navigate(isTablet ? '/lkart/admin/tablet-scanner' : '/lkart/admin/view');
    }
  }, [navigate, token]);

  const handleSendOtp = async () => {
    try {
      if (!acceptedTerms) {
        setError('You must accept the Terms and Conditions to continue.');
        setShowError(true);
        return;
      }
      if (phone.length === 10) {
        logout();
        const res = await adminLogin(phone);
        if (res.success === true) {
          setShowOtp(true);
        } else {
          setError(res.message);
          setShowError(true);
        }
      }
    } catch (err) {
      setError('Your phone number is not registered with us.');
      setShowError(true);
    }
  };

  const handleVerifyOtp = async () => {
    try {
      if (otp.length === 4) {
        const data = await verifyAdminOtp(phone, otp);
        if (data.success) {
          const isTablet = data?.isTablet ?? false;
          const params = new URLSearchParams(window.location.search);
          const returnUrl = params.get('returnUrl');
          if (isTablet) {
            navigate('/lkart/admin/tablet-scanner');
          } else {
            navigate(returnUrl || '/lkart/admin/view');
          }
        } else {
          setError(data.message);
          setShowError(true);
        }
      }
    } catch (err) {
      setError('Invalid OTP. Please try again.');
      setShowError(true);
    }
  };

  const handlePhoneChange = (e) => setPhone(e.target.value.replace(/\D/g, ''));
  const handlePhoneKeyPress = (e) => {
    if (e.key === 'Enter' && phone.length === 10 && !loading) handleSendOtp();
  };
  const handleOtpKeyPress = (e) => {
    if (e.key === 'Enter' && otp.length === 4 && !loading) handleVerifyOtp();
  };

  return (
    <>
      <PhoneOtpForm
        logoSrc={FactorykaOnDemand}
        headingLines={['Welcome to Factrika']}
        showOtp={showOtp}
        phone={phone}
        onPhoneChange={handlePhoneChange}
        onPhoneKeyPress={handlePhoneKeyPress}
        acceptedWhatsApp={acceptedWhatsApp}
        acceptedTerms={acceptedTerms}
        onAcceptedTermsChange={(e) => setAcceptedTerms(e.target.checked)}
        otp={otp}
        onOtpChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
        onOtpKeyPress={handleOtpKeyPress}
        onSendOtp={handleSendOtp}
        onVerifyOtp={handleVerifyOtp}
        loading={loading}
      />
      <ErrorModal message={error} isOpen={showError} setIsOpen={setShowError} />
    </>
  );
};

export default AdminLogin;